import { jsx, jsxs } from 'react/jsx-runtime';
import { useState } from 'react';
import { useOverflow } from '../../../hooks/useOverflow.es.js';

const root = "_root_1mssy_1";
const content = "_content_1mssy_8";
const toggle = "_toggle_1mssy_21";
const styles = {
	root: root,
	content: content,
	toggle: toggle
};

const AlertDescription = ({ children, maxLines = 3 }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOverflowing, setOverflowingNode] = useOverflow();
  const toggle = isOverflowing && jsx("button", { className: styles.toggle, onClick: () => setIsOpen(!isOpen), type: "button", "data-zds": true, children: isOpen ? "show less" : "show more" });
  return jsxs("div", { className: styles.root, "data-zds": true, children: [jsx("div", { className: styles.content, "data-zds": true, ref: setOverflowingNode, style: {
    "--line-clamp": isOpen ? "initial" : maxLines
  }, children: jsx("div", { "data-zds": true, children }) }), toggle] });
};

export { AlertDescription };
//# sourceMappingURL=AlertDescription.es.js.map
